import * as React from "react";
import { conference } from "@/api";
import MeetItem from "./MeetItem";
import styled from "styled-components";
import { Button, message, Modal,Checkbox } from "antd";
import { useHistory } from "react-router-dom";

import AppointPreview from "./preview";
import AppointEdit from "./edit";
import { ConferenceInterface } from "@/types";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 12px 12px 0;
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #999;
    height: 30px;
  }
  .main {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    border: 1px solid #eee;
    border-radius: 3px;
  }
  .footer {
    height: 50px;
    display: flex;
    flex-direction: line;
    justify-content: center;
    align-items: center;
    width: 100%;
    .cancel {
      margin-left: 70px;
    }
  }
`;

const AppointmentMeeting: React.FunctionComponent = () => {
  const history = useHistory();
  const [records, setRecords] = React.useState([]);
  const [editConf, setEditConf] = React.useState<ConferenceInterface>(null);
  const [viewConf, setViewConf] = React.useState<ConferenceInterface>(null);

  React.useEffect(() => {
    getMeetings();
  }, []);

  const getMeetings = async () => {
    const params = {
      pageNum: 0,
      pageSize: 100,
      param: {},
    };
    const ret = await conference.orderList(params);
    setRecords(ret.records || []);
  };

  const newappoint = () => {
    history.push("/main/appointnew");
  };
  const btnDeleteAll =()=>{
    Modal.confirm({
      title: "删除",
      content: "确定要删除所有会议？",
      onOk: () => deleteAll(),
      okText: "确定",
      cancelText: "取消",
    });
  }

  const deleteAll = async () => {
    // await conference.conferenceDeleteAll();
    message.success("所有会议已删除");
    setViewConf(null);
    getMeetings();
  };
  const onItemOperation = (roomId: string, operation: string) => {
    const meeting = records.find((item) => item.roomId === roomId);
    if (operation === "delete") {
      Modal.confirm({
        title: "删除",
        content: "确定要删除该会议？",
        onOk: () => deleteConference(meeting),
        okText: "确定",
        cancelText: "取消",
      });
    }
    if (operation === "view") setViewConf(meeting as ConferenceInterface);
    if (operation === "modify") setEditConf(meeting as ConferenceInterface);
  };

  const deleteConference = async (conf: any) => {
    const { id } = conf;
    await conference.conferenceDelete(id);
    message.success("会议已删除");
    setViewConf(null);
    getMeetings();
  };

  const editFinish = () => {
    setEditConf(null);
    getMeetings();
  };

  return (
    <Container>
      {!!editConf && (
        <AppointEdit
          conference={editConf}
          onClose={() => setEditConf(null)}
          editFinish={editFinish}
        ></AppointEdit>
      )}
      <AppointPreview
        conference={viewConf}
        onClose={() => setViewConf(null)}
        onDelete={onItemOperation}
      ></AppointPreview>
      <div className="header">
        <span>预约会议</span>
      </div>
      <div className="main">
        {records.map((x) => (
          <MeetItem
            key={x.conferenceNo}
            item={x}
            onOperation={onItemOperation}
          />
        ))}
      </div>
      <div className="footer">
        <Button type="primary" onClick={newappoint}>
          新建预约
        </Button>
        {/* <Button danger type="primary" onClick={btnDeleteAll} className="cancel">
          删除所有
        </Button> */}
      </div>
    </Container>
  );
};

export default AppointmentMeeting;
